import type { FC } from 'react';
import { useQuery } from '@tanstack/react-query';

import { CabinetBanner } from 'components/CabinetBanner';
import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { api, type ApiRequestConfig } from 'api/v1/api';
import { GrainsIcon } from 'ui/icons/Grains.icon';

import {
  isStudentCompletionNagShown,
  studentCompletionNagItems,
  type StudentReadiness,
} from './studentCompletionNag';

export const StudentProfileCompletionBanner: FC = () => {
  const { data: session } = useAuthSession();

  const { data } = useQuery<StudentReadiness>({
    queryKey: ['student-profile-readiness'],
    queryFn: () =>
      api
        .get('/profile/student/readiness', {
          skipGlobalErrorHandler: true,
        } as ApiRequestConfig)
        .then((r) => r.data),
    enabled: isAuthSessionActive(session),
    staleTime: 60_000,
    retry: false,
  });

  if (!isStudentCompletionNagShown(data)) {
    return null;
  }

  return (
    <CabinetBanner
      variant='warning'
      icon={<GrainsIcon />}
      title='Заполни профиль, чтобы открыть заявки'
      text={data.message}
      items={studentCompletionNagItems(data)}
      linkTo='/profile'
      linkLabel='К редактированию профиля'
    />
  );
};
